import React, { Component } from 'react';
import { Card, Form, Divider, Select, Row, Col, Input } from 'antd';
import { inject, observer } from 'mobx-react';

@inject('store')
@observer
export class MessageBuilder extends Component {
    constructor(props) {
        super(props);

        this.state = {
            form: {
                action: 'buy',
                symbol: '',
                group: '',
                secret: props.secret || ''
            }
        };
    }

    render() {
        return (
            <Card title="Message Builder" style={{ marginTop: 15 }} size={'small'}>
                <Form>
                    <Row gutter={24}>
                        <Col md={8}>
                            <Form.Item label={'Action'} required>
                                <Select
                                    value={this.state.form.action}
                                    onChange={action => {
                                        let next = { ...this.state.form };
                                        next.action = action;
                                        if (action === 'buy') {
                                            delete next.order_type;
                                        } else if (action === 'sell') {
                                            delete next.strategy;
                                            next.order_type = 'limit';
                                        }
                                        console.log(next);
                                        this.setState({ form: next });
                                    }}
                                >
                                    <Select.Option value={'buy'}>Buy</Select.Option>
                                    <Select.Option value={'sell'}>Sell</Select.Option>
                                    <Select.Option value={'change_strategy'}>
                                        Change Strategy
                                    </Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col md={8}>
                            <Form.Item label={'Symbol'} required>
                                <Select
                                    showSearch
                                    value={this.state.form.symbol}
                                    onChange={symbol => {
                                        let next = { ...this.state.form };
                                        next.symbol = symbol;
                                        this.setState({ form: next });
                                    }}
                                    filterOption={(input, option) =>
                                        option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {Object.keys(this.props.store.botStore.marketStore.market).map(
                                        symbol => {
                                            const name = this.props.store.botStore.marketStore
                                                .market[symbol].name;

                                            return (
                                                <Select.Option value={name} key={symbol}>
                                                    {symbol}
                                                </Select.Option>
                                            );
                                        }
                                    )}
                                </Select>
                            </Form.Item>
                        </Col>

                        {this.state.form.action === 'buy' ||
                        this.state.form.action === 'change_strategy' ? (
                            <Col md={8}>
                                <Form.Item label={'Strategy'} required>
                                    <Select
                                        showSearch
                                        value={this.state.form.strategy}
                                        onChange={strategy => {
                                            let next = { ...this.state.form };
                                            next.strategy = strategy;
                                            this.setState({ form: next });
                                        }}
                                    >
                                        {this.props.store.strategyStore.signal
                                            .slice()
                                            .sort((a, b) => {
                                                if (a.name < b.name) return -1;
                                                if (a.name > b.name) return 1;
                                                return 0;
                                            })
                                            .map(s => {
                                                return (
                                                    <Select.Option value={s.id} key={s.id}>
                                                        {s.name}
                                                    </Select.Option>
                                                );
                                            })}
                                    </Select>
                                </Form.Item>
                            </Col>
                        ) : null}

                        {this.state.form.action === 'sell' ? (
                            <Col md={8}>
                                <Form.Item label={'Order Type'} required>
                                    <Select
                                        showSearch
                                        value={this.state.form.order_type}
                                        onChange={order_type => {
                                            let next = { ...this.state.form };
                                            next.order_type = order_type;
                                            this.setState({ form: next });
                                        }}
                                    >
                                        <Select.Option value={'market'}>Market</Select.Option>
                                        <Select.Option value={'limit'}>Limit</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        ) : null}

                        {this.state.form.side === 'sell' && this.state.order_type === 'limit' ? (
                            <Col md={8}>
                                <Form.Item label={'Price'}>
                                    <Input
                                        value={this.state.form.price}
                                        onChange={e => {
                                            let next = { ...this.state.form };
                                            next.price = e.target.value;
                                            this.setState({ form: next });
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        ) : null}

                        <Col md={8}>
                            <Form.Item label={'Group'}>
                                <Input
                                    value={this.state.form.group}
                                    onChange={e => {
                                        let next = { ...this.state.form };
                                        next.group = e.target.value;
                                        this.setState({ form: next });
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>

                <Divider orientation="left">Alert Message</Divider>

                <pre>{JSON.stringify(this.state.form, null, 2)}</pre>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/SignalsView/TradingViewApi/MessageBuilder.js